import { useMutation } from "@tanstack/react-query"
import { createComment } from "@/api/comments/createComment"

export const useCreateComment = () => {
  
  return useMutation({
    mutationKey: ["createComment"],
    mutationFn: createComment
  })
}